import { useMemo } from 'react'

import { useActiveOrg } from '~/hooks/org'
import { useAuthUser } from '~/hooks/useAuthUser'

export const useOnboarding = () => {
  const { user } = useAuthUser()
  const { org: activeOrg, isFetchedAfterMount } = useActiveOrg()

  const numTeamOrgs = user?.orgs.filter(
    (org) => org.isPersonal === false,
  ).length

  const isActiveOrgOnboarding =
    !!activeOrg &&
    !activeOrg.isPersonal &&
    activeOrg.smartAccountSetup?.currentStep !== 'COMPLETED' &&
    activeOrg.smartAccountSetup?.currentStep !== 'SKIPPED'

  const isOnboarding = numTeamOrgs === 0 || isActiveOrgOnboarding

  const isFirstOnboarding =
    isOnboarding && (numTeamOrgs === 0 || numTeamOrgs === 1)

  return useMemo(
    () => ({
      isFirstOnboarding,
      isOnboarding,
      isDataLoaded: isFetchedAfterMount,
    }),
    [isFirstOnboarding, isOnboarding, isFetchedAfterMount],
  )
}
